import { lazy } from 'react';
import { Route } from 'react-router-dom';

// 微信绑定
const WeChatBind = lazy(() =>
  import(/* webpackChunkName: "WeChatBind" */ 'src/views/Conti/WeChatBind')
);
const ContiRouter = {
  '/Conti/WeChatBind': WeChatBind
};
export default function ContiSafetyRoute() {
  const keys = Object.keys(ContiRouter);
  const routeArr = keys.map(key => {
    const Components = ContiRouter[key];
    return <Route key={key} path={key} element={<Components />} />;
  });
  return routeArr;
}
